(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["promotion_pro_products"] && !Shopify.designMode) return;
  try {
    const initPromotionProProductVariants = (root = document) => {
    root.querySelectorAll('[data-promotion-pro-product]').forEach((product) => {
      const image = product.querySelector('[data-promotion-pro-image]');
      const imageLink = product.querySelector('[data-promotion-pro-image-link]');
      const price = product.querySelector('[data-promotion-pro-price]');
      const comparePrice = product.querySelector('[data-promotion-pro-compare-price]');
      const saveBadge = product.querySelector('[data-promotion-pro-save-badge]');
      const saveMoney = product.querySelector('[data-promotion-pro-save-money]');
      const variantInput = product.querySelector('[data-promotion-pro-variant-input]');
      const variantDataScript = product.querySelector('.promotion-pro-product__variant-data');
      const optionWrap = product.querySelector('[data-promotion-pro-variant-options]');
      const learnMore = product.querySelector('[data-promotion-pro-learn-more]');
      const submit = product.querySelector('[data-promotion-pro-submit]');
      const submitText = product.querySelector('[data-promotion-pro-submit-text]');
      const addText = submitText ? submitText.textContent : '';
      const soldOutText = product.dataset.soldOutText || 'Sold out';
      const hasVariantOptions = Boolean(optionWrap);
      let variants = [];

      if (variantDataScript) {
        try {
          variants = JSON.parse(variantDataScript.textContent || '[]');
        } catch (error) {
          variants = [];
        }
      }

      const findVariantForOption = (option) => {
        if (!option) return null;

        const manualId = option.dataset.variantIdManual || option.dataset.variantId;
        const title = option.dataset.variantTitle;

        if (manualId) {
          const manualIdString = String(manualId);
          const foundById = variants.find((variant) => String(variant.id) === manualIdString);
          if (foundById) return foundById;
        }

        if (title) {
          return variants.find((variant) => variant.title === title) || null;
        }

        return null;
      };

      const updateVariant = (variant, option) => {
        if (!variant) return;

        if (variantInput) {
          variantInput.value = variant.id;
        }

        const nextImage = option && option.dataset.customImage ? option.dataset.customImage : variant.image;
        if (image && nextImage) {
          image.src = nextImage;
          image.removeAttribute('srcset');
          if (!option || !option.dataset.customImage) {
            if (variant.srcset) image.srcset = variant.srcset;
          }
          if (variant.imageAlt) image.alt = variant.imageAlt;
        }

        if (price && variant.price) {
          price.textContent = variant.price;
        }

        if (comparePrice) {
          comparePrice.textContent = variant.comparePrice || '';
          comparePrice.hidden = variant.hasCompare !== true;
        }

        if (saveBadge) {
          saveBadge.hidden = variant.hasCompare !== true || !variant.saveMoney;
          if (saveMoney) saveMoney.textContent = variant.saveMoney || '';
        }

        if (learnMore && variant.url) {
          learnMore.href = variant.url;
        }

        if (imageLink && variant.url) {
          imageLink.href = variant.url;
        }

        if (submit) {
          submit.disabled = !variant.available;
          if (submitText) submitText.textContent = variant.available ? addText : soldOutText;
        }

        if (optionWrap) {
          optionWrap.querySelectorAll('button').forEach((button) => {
            const active = button === option;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        }
      };

      if (optionWrap && optionWrap.dataset.promotionProReady !== 'true') {
        optionWrap.dataset.promotionProReady = 'true';
        const options = Array.from(optionWrap.querySelectorAll('button'));

        options.forEach((option) => {
          const variant = findVariantForOption(option);
          if (!variant) return;

          option.dataset.variantId = variant.id;
          option.disabled = !variant.available;
          option.setAttribute('aria-label', option.getAttribute('aria-label') || variant.title);
          option.addEventListener('click', () => updateVariant(variant, option));
        });

        const initialOption = options.find((option) => option.classList.contains('is-active')) || options.find((option) => !option.disabled) || options[0];
        updateVariant(findVariantForOption(initialOption) || variants[0], initialOption);
      } else if (!hasVariantOptions && variants[0]) {
        updateVariant(variants[0], null);
      }
    });
  };

  initPromotionProProductVariants();
  document.addEventListener('shopify:section:load', (event) => initPromotionProProductVariants(event.target));
  } catch(e) { console.error(e); }
})();

})();
